import { createSlice } from '@reduxjs/toolkit';
export const initialState = {};
export const DeclineProposedTimeSlice = createSlice({
    name: 'declineProposedTime',
    initialState,
    reducers: {
        declineNewTime(_state, _action) {
            // No-op implementation for initial state
        },
    },
});
export const { declineNewTime } = DeclineProposedTimeSlice.actions;
export default DeclineProposedTimeSlice.reducer;
